import { NgModule } from '@angular/core';
import { ViewSettingsComponent } from './view-settings.component';
import { SharedProviderModule } from '../../shared/shared.module';
import { IntercomService } from '../../shared/intercom.service';
import { StateService } from '../../shared/state/state.service';
import { FavoriteService } from '../../toolbar/favorite/favorite.service';
import { UserSettingsModule } from '../../components/user-settings/user-settings.module';
import { WeatherModule } from '../../weather/weather.module';
import { TodayModule } from '../../today/today.module';
import { QmPipesModule } from '../../components/qm-pipes/qm-pipes.module';
import { QmDirectivesModule } from '../../components/qm-directives/qm-directives.module';
import { OverlayPanelModule } from '../../components/overlay-panel/overlay-panel.module';
import { VrgroupModule } from '../../custom/vrgroup/vrgroup.module';
import { FavoriteModule } from '../../toolbar/favorite/favorite.module';
import { MapSettingsModule } from '../../shared/map/components/map-settings/map-settings.module';
import { NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { DirectionsModule } from '~shared/map/components/directions/directions.module';
import { MonitorsModule } from '../../components/monitors/monitors.module';

@NgModule({
  imports: [
    MapSettingsModule,
    DirectionsModule,
    FavoriteModule,
    SharedProviderModule,
    TodayModule,
    UserSettingsModule,
    QmPipesModule,
    QmDirectivesModule,
    OverlayPanelModule,
    WeatherModule,
    VrgroupModule,
    NgbTooltipModule,
    NgbModalModule,
    MonitorsModule
  ],
  declarations: [ViewSettingsComponent],
  exports: [ViewSettingsComponent],
  providers: [StateService, FavoriteService, IntercomService]
})
export class ViewSettingsModule {
}
